
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.991 3.95a1 1 0 00-1.51-.86 7.48 7.48 0 01-1.874.795 5.152 5.152 0 00-3.374-1.242 5.232 5.232 0 00-5.223 5.063 11.032 11.032 0 01-6.814-3.924 1.012 1.012 0 00-.857-.365 1 1 0 00-.785.5 5.276 5.276 0 00-.242 4.769H2.31a1.041 1.041 0 00-.496.89c-.001.147.008.294.027.44a5.185 5.185 0 001.568 3.312.998.998 0 00-.066.77 5.204 5.204 0 002.362 2.922 7.464 7.464 0 01-3.59.448A1 1 0 001.45 19.3a12.941 12.941 0 007.01 2.06A12.788 12.788 0 0020.925 12c.353-1.184.533-2.412.535-3.646v-.2A5.77 5.77 0 0022.99 3.95zm-3.306 3.213a.995.995 0 00-.234.702c.01.165.01.33.01.488a10.822 10.822 0 01-.455 3.08 10.685 10.685 0 01-10.546 7.93c-.859 0-1.715-.101-2.55-.301a9.48 9.48 0 002.942-1.564 1 1 0 00-.602-1.786 3.208 3.208 0 01-2.214-.935 4.95 4.95 0 00.445-.105 1 1 0 00-.08-1.943 3.197 3.197 0 01-2.25-1.726c.18.024.363.04.545.046a1.02 1.02 0 00.984-.696 1 1 0 00-.4-1.137 3.196 3.196 0 01-1.419-2.871 13.014 13.014 0 008.21 3.48 1.02 1.02 0 00.817-.36 1 1 0 00.206-.867 3.163 3.163 0 01-.087-.73 3.23 3.23 0 014.505-2.961c.404.175.767.433 1.066.756a.993.993 0 00.921.298 9.27 9.27 0 001.212-.322 6.68 6.68 0 01-1.026 1.524z","fill":"#B1AFCD"}})])
          )
        }
      }
    